// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { xGoogleAnalyticsState } from "@werner/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@werner/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { connect } from "react-redux";

interface OwnProps {
    title: string;
    wishListId: string;
    testSelector: string;
}

// Xng-Change
const mapStateToProps = (state: xGoogleAnalyticsState) => {
    return {
        xGoogleAnalytics: state.xGoogleAnalytics,
        wishlistDetailsUrl: getPageLinkByPageType(state, "MyListsDetailsPage")?.url,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const MyListsDetailsPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    wishListId,
    testSelector,
    // Xng-Change
    xGoogleAnalytics,
    wishlistDetailsUrl,
}) => {
    /**
     * Xng-Change
     * WES-1766
     * Push view_product_list event to dataLayer if a user clicked on wishlist name
     */
    const onClickHandler = () => {
        const dataLayer = getDataLayer();
        if (dataLayer && xGoogleAnalytics.viewWishlistEvent) {
            const googleAnalyticsData = {
                event: xGoogleAnalytics.viewWishlistEventName,
                click_text: title,
                destination: `${wishlistDetailsUrl}?id=${wishListId}`,
                affiliation: xGoogleAnalytics.affiliation,
            };
            dataLayer.push(googleAnalyticsData);
        }
    };

    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            testSelector,
            pageType: "MyListsDetailsPage",
            overrideTitle: title,
            queryString: `id=${wishListId}`,
        },
        onClickHandler,
    } as any);
};

export default connect(mapStateToProps)(MyListsDetailsPageTypeLink);
